import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'

import {
  _fetchAlerts,
  _saveAlert,
  _removeAlert,
  _fetchAlertHistories,
} from '../api'

let name = 'alerts'
export const fetchAlerts= createAsyncThunk(
  `${name}/fetchAlerts`,
  async (_args, {getState, dispatch}) => {
    try {
      let response = await _fetchAlerts(_args)
      dispatch(setAlerts(response?.result))
    } catch (error) {
      console.log("error:",error)
      console.error(error)
    }

    return []
  }
)

export const fetchAlertHistories= createAsyncThunk(
  `${name}/fetchAlertHistories`,
  async (_args, {getState, dispatch}) => {
    try {
      let response = await _fetchAlertHistories(_args)
      dispatch(setAlertHistories(response?.result))
    } catch (error) {
      console.log("error:",error)
      console.error(error)
    }

    return []
  }
)

export const saveAlert= createAsyncThunk(
  `${name}/saveAlert`,
  async (_args, {getState, dispatch}) => {
    try {
      let response = await _saveAlert(_args)
      if (response.success) {
        // Refresh the alerts list after successful save
        dispatch(fetchAlerts())
      }
      return response
    } catch (e) {
      console.log("error:",e)
      console.error(e)
      return {success: false , response: e.message || 'Erreur' }
    }

  }
)

export const removeAlert= createAsyncThunk(
  `${name}/removeAlert`,
  async (alertId, {getState, dispatch}) => {
    try {
      let response = await _removeAlert(alertId)
      if (response.success) {
        // Refresh the alerts list after successful deletion
        dispatch(fetchAlerts())
      }
      return response
    } catch (e) {
      console.log("error:",e)
      console.error(e)
      return {success: false , response: e.message || 'Erreur' }
    }
  }
)

const alertsSlice = createSlice({
  name,
  initialState: {
    alerts:[],
    histories: [],
    edit: false,
    selected: null
  },
  reducers: {
    setAlerts: (state, {payload}) => {
      state.alerts = payload
    },
    setAlertHistories: (state, {payload}) => {
      state.histories = payload
    },
    setSelectedAlert: (state, {payload}) => {
      state.selected = payload
    },
    setEditAlert: (state, {payload}) => {
      state.edit = payload
    }
  },
})

export const getAlerts = (state) => state[name].alerts
export const getAlertHistories = (state) => state[name].histories
export const getSelectedAlert = (state) => state[name].selected
export const getEditAlert = (state) => state[name].edit

export const {
  setAlerts,
  setAlertHistories,
  setSelectedAlert,
  setEditAlert
} = alertsSlice.actions
export default alertsSlice.reducer
